export default __webpack_public_path__ + "static/media/airbnb.138c1987.png";